module.exports = __webpack_public_path__ + "img/logo-onyxerp-invertido.b17b460a.svg";